import React, { PureComponent } from 'react';

import { FontIcon, ListItem, SelectionControlGroup, Divider } from 'lib/react-md'

import TextFieldEdit from 'components/common/TextFieldEdit'
import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'

import './FeedbackCardView.css'

class FeedbackCardView extends PureComponent {

	updateProperty = (property) => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	render() {
		const { node, actionHandler } = this.props;
		const { nodeHandler } = actionHandler;
		const { title, inputType, items, value } = node.properties;

		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;

		const renderTitle = () => title || "Neues Feedback-Element";

		const renderChoices = () => {
			switch (inputType) {
				case "text":
					return <TextFieldEdit
						ref={c => this.textFieldText = c}
						id={`feedback-text-input-${node.$id}`}
						name={`feedback-text-input-${node.$id}`}
						type="title"
						label="Platz für Ihr Feedback"
						value={value}
						onSubmit={value => this.updateProperty({value})}
						rightIcon={<FontIcon className="icon-done-stateful"
						                     onClick={() => actionHandler.addToast("Antwort gespeichert")}>done</FontIcon>}
					/>;

				case "radio":
					return <SelectionControlGroup
						id={`feedback-radio-input-${node.$id}`}
						name={`feedback-radio-input-${node.$id}`}
						type="radio"
						value={value}
						controls={items}
						checkedRadioIcon={<FontIcon>check</FontIcon>}
						uncheckedRadioIcon={<FontIcon style={{color: "#D2D2D2"}}>radio_button_unchecked</FontIcon>}
						onChange={value => this.updateProperty({ value })}
					/>;

				case "checkbox":
					return <SelectionControlGroup
						id={`feedback-checkbox-input-${node.$id}`}
						name={`feedback-checkbox-input-${node.$id}`}
						type="checkbox"
						value={value}
						controls={items}
						checkedCheckboxIcon={<FontIcon>check</FontIcon>}
						uncheckedCheckboxIcon={<FontIcon style={{color: "#D2D2D2"}}>check_box_outline_blank</FontIcon>}
						onChange={value => this.updateProperty({ value: value.replace(/(^[,\s]+)|([,\s]+$)/g, '') })} /* remove leading comma */
					/>;

				default:
					return null
			}
		};

		const renderContent = () => (
			<div className="feedback-card-item" id={node.$id}>
				<ListItem
					primaryText={renderTitle()}
					secondaryText={renderChoices()}
					disabled
				/>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Frage wird gelöscht..." />;

		return (
			<div className="feedback-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="feedback-card-item-divider"/>
			</div>
		)
	}

}

export default FeedbackCardView;


// WEBPACK FOOTER //
// ./src/components/cards/feedback/default/FeedbackCardView.jsx